import { render, staticRenderFns } from "./radio-widget.vue?vue&type=template&id=0b24e34a&scoped=true&"
import script from "./radio-widget.vue?vue&type=script&lang=js&"
export * from "./radio-widget.vue?vue&type=script&lang=js&"
import style0 from "./radio-widget.vue?vue&type=style&index=0&id=0b24e34a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b24e34a",
  null
  
)

export default component.exports